import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { CaseInfo } from '../../data/types';

export type RecentCaseState = {
    cases: CaseInfo[],
}

export const useRecentCaseState = () => {
    const recentCaseState = useSelector((state: RootState | any) => state.recentCases as RecentCaseState);
    return recentCaseState;
}

// Define the initial state using that type
const initialState: RecentCaseState = {
    cases: [],
}

export const recentCaseSlice = createSlice({
    name: 'recentCases',
    initialState: initialState,
    reducers: {
        setRecentCasesAction: (state, action: PayloadAction<CaseInfo[]>) => {
            state.cases = action.payload;
        },
        addRecentCaseAction: (state, action: PayloadAction<CaseInfo>) => {
            const filteredCases = state.cases.filter((x) => x.caseId != action.payload.caseId);
            state.cases = [action.payload, ...filteredCases.slice(0, 4)];
        },
        removeRecentCaseAction: (state, action: PayloadAction<CaseInfo>) => {
            const filteredCases = state.cases.filter((x) => x.caseId != action.payload.caseId);

            state.cases = [...filteredCases.slice(0, 4)];
        },
        removeRecentCaseByIdAction: (state, action: PayloadAction<string>) => {
            const filteredCases = state.cases.filter((x) => x.caseId != action.payload);

            state.cases = [...filteredCases.slice(0, 4)];
        },
    }
})

export const { addRecentCaseAction, setRecentCasesAction, removeRecentCaseAction, removeRecentCaseByIdAction } = recentCaseSlice.actions;

export default recentCaseSlice.reducer;